import React, {useEffect, useState} from "react";
import {Breadcrumb, Button, Card, Col, Form, Row} from "react-bootstrap";
import ContactService from "../../services/contact.service";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import {CONTACT_CATEGORIES, isLoggedIn} from "../../common/utils";
import {useForm} from "react-hook-form"
import Container from "react-bootstrap/Container";
import AuthService from "../../services/auth.service";

const ContactForm = () => {

    const [senderEmail, setSenderEmail] = useState("")

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
    } = useForm()

    const reactQuillRef = React.useRef();

    // limit to 1500 characters
    const checkCharacterCount = (event) => {
        // event.preventDefault();
        const unprivilegedEditor = reactQuillRef.current.unprivilegedEditor;
        if (unprivilegedEditor.getLength() > 1500 && event.key !== 'Backspace') {
            window.alert("You've reached the maximum character count of 1500.")
        }
    };

    const onEditorStateChange = (editorState) => {
        // disabling matchVisual did not work: https://stackoverflow.com/questions/43748108/how-to-keep-quill-from-inserting-blank-paragraphs-pbr-p-before-heading
        if (editorState === "<p><br></p>") {
            editorState = ""
        }
        setValue("contactMessage", editorState);
    };

    // cannot register contactMessage like the other fields because the input type is react-quill
    useEffect(() => {
        register("contactMessage", {required: true});
        setValue("contactMessage", "");
        let loggedIn = isLoggedIn();
        if (loggedIn) {
            let currentUser = AuthService.getCurrentUser();
            setSenderEmail(currentUser.email);
            setValue("contactSenderEmail", currentUser.email);
        }
    }, [register]);  // eslint-disable-line react-hooks/exhaustive-deps

    // todo: handle backend errors (non-200 or 204)
    const handleSubmitRHF = (data) => {
        let payload = {
            message: data.contactMessage,
            category: data.contactCategory,
            sender_email: data.contactSenderEmail,
        }
        console.log("payload: " + JSON.stringify(payload))

        ContactService.createContact(payload).then(
            response => {
                window.location.assign("/contact-thankyou");
            },
            error => {
                console.log(error);
            });
    }

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h3>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Contact</Breadcrumb.Item>
                        </Breadcrumb>
                    </h3>
                </Col>
            </Row>

            <Row>
                <Col>
                    {/*"handleSubmit" will validate your inputs before invoking "onSubmit"*/}
                    <Form onSubmit={handleSubmit(handleSubmitRHF)}>

                        <Row className="mb-3">
                            <Col>
                                <div>Please fill out the form below:</div>
                                <div className="text-danger">
                                    <span className="fs-5 text">*</span> Indicates a required field
                                </div>
                            </Col>
                        </Row>

                        <Card>
                            <Card.Body>
                                <div className="mb-3">
                                    <strong>Category</strong>&nbsp;<span className="fs-5 text text-danger">*</span>
                                </div>
                                <div>
                                    <Form.Select
                                        // defaultValue={contact.category}
                                        {...register("contactCategory", {required: true})}>
                                        {CONTACT_CATEGORIES.map((cc, index) => (
                                            <option key={index} value={cc.value}>{cc.name}</option>
                                        ))}
                                    </Form.Select>
                                    {errors.contactCategory &&
                                        <span className="pf-validation-error">This field is required</span>}
                                </div>
                            </Card.Body>
                        </Card>

                        <Card>
                            <Card.Body>
                                <div className="mb-3">
                                    <strong>Email</strong>&nbsp;<span className="fs-5 text text-danger">*</span>
                                </div>
                                <div>
                                    {/* register your input into the hook by invoking the "register" function */}
                                    <Form.Control
                                        type="text"
                                        defaultValue={senderEmail}
                                        {...register("contactSenderEmail", {
                                            required: true,
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                            }
                                        })}
                                    />
                                    {errors.contactSenderEmail && <span className="pf-validation-error">A valid email address is required</span>}
                                </div>
                            </Card.Body>
                        </Card>

                        <Card>
                            <Card.Body>
                                <div className="mb-3">
                                    <strong>Message</strong>&nbsp;<span className="fs-5 text text-danger">*</span>
                                </div>
                                <div>
                                    {/* see: https://github.com/zenoamaro/react-quill */}
                                    <ReactQuill theme="snow"
                                        // defaultValue={contact.message}
                                                onChange={onEditorStateChange}
                                                modules={{
                                                    toolbar: [
                                                        // [{ 'header': [1, 2, false] }],
                                                        ['bold', 'italic', 'underline'],
                                                        [{'list': 'ordered'}, {'list': 'bullet'}],
                                                        ['link'],
                                                        ['clean']
                                                    ],
                                                    // this is needed to eliminate the <p><br></p> problem
                                                    clipboard: {
                                                        matchVisual: false
                                                    }
                                                }}
                                        // placeholder={""}
                                                onKeyDown={checkCharacterCount}
                                                ref={reactQuillRef}
                                    />
                                    {errors.contactMessage &&
                                        <span className="pf-validation-error">This field is required</span>}
                                </div>
                            </Card.Body>
                        </Card>

                        <Row className="mb-3">
                            <Col sm={12}>
                                <Button type="submit">Submit</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
};

export default ContactForm;
